'use client'
import { Button } from 'antd'

const LinkSeeMore = ({ className, children, onClick }) => {
  return (
    <Button
      className={className}
      type="link"
      style={{ padding: 0, color: 'var(--color-primary)' }}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}

export default LinkSeeMore
